/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelettivaListByPosizioneRequestDto } from '../../models/selettiva-list-by-posizione-request-dto';
import { SelettivaMarcatoreDto } from '../../models/selettiva-marcatore-dto';

export interface ApiMarcatoreSelettivaListByPosizionePost$Params {
    /**
     * Oggetto contenente la posizione dei quattro angoli che delimitano il rettangolo
     */
    body: SelettivaListByPosizioneRequestDto;
}

export function apiMarcatoreSelettivaListByPosizionePost(
    http: HttpClient,
    rootUrl: string,
    params: ApiMarcatoreSelettivaListByPosizionePost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<SelettivaMarcatoreDto>>> {
    const rb = new RequestBuilder(rootUrl, apiMarcatoreSelettivaListByPosizionePost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<SelettivaMarcatoreDto>>;
        }),
    );
}

apiMarcatoreSelettivaListByPosizionePost.PATH = '/api/marcatore/selettiva-list-by-posizione';
